import { config, authHeader } from '../helpers'
import { handleHttpResponse } from '../helpers';

export const PodRequestService = {
    getAdminPodRequests,
    getUserPodRequests,
    changeStateOfHpRequest
}

// loads the variable with its meterings
function getAdminPodRequests({ adminID, isPendingRequest, pageIndex, nbElPerPage, EAN, dgo }) {
  const query = `{
      adminPodRequests(
            adminID:${JSON.stringify(adminID)},
            isPendingRequest: ${isPendingRequest},
            pageIndex: ${pageIndex},
            nbElPerPage: ${nbElPerPage},
            EAN: ${EAN ? JSON.stringify(EAN) : null},
            dgo: ${JSON.stringify(dgo)}
        ) {
        podRequests {
          id
          clientID
          firstName
          lastName
          phone
          mail
          dgo
          EAN
          meter
          streetName
          streetNumber
          boxNumber
          localityName
          postalCode
          comment
          requestDate
          endOfContractDetected
          endOfContractDate
          actionHistory {
            date
            admin
            accepted
            refuseRequestReason
          }
          client {
              email
          }
        }
        lastPage
        nbFiltered
      }
  }`
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/graphql', ...authHeader() },
    body: query
  }
    return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
    return handleHttpResponse(response)
    .then(data => data.adminPodRequests)
    })
}

// userPodRequests endpoint
function getUserPodRequests({ userID, pageIndex, nbElPerPage }) {
  const query = `{
    userPodRequests(
            userID:${JSON.stringify(userID)},
            pageIndex: ${pageIndex},
            nbElPerPage: ${nbElPerPage}
        ) {
        podRequests {
          id
          clientID
          firstName
          lastName
          phone
          mail
          delegation
          delegatedFirstName
          delegatedLastName
          delegatedPhone
          delegatedMail
          EAN
          meter
          fluid
          streetName
          streetNumber
          boxNumber
          localityName
          postalCode
          comment
          evidence
          requestDate
          status
          endOfContractDetected
          endOfContractDate
          actionHistory {
            date
            accepted
            refuseRequestReason
          }
        }
        lastPage
        nbFiltered
      }
  }`
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/graphql', ...authHeader() },
    body: query
  }
    return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
    return handleHttpResponse(response)
    .then(data => data.userPodRequests)
    })
}

function changeStateOfHpRequest({ accept, adminID, podReqID, date, refuseRequestReason }) {
  const query = `{
    changeStateOfHpRequest(
      accept: ${accept},
      adminID: ${JSON.stringify(adminID)},
      podReqID: ${JSON.stringify(podReqID)},
      date: ${JSON.stringify(date)},
      refuseRequestReason: ${JSON.stringify(refuseRequestReason)}
    ) {
      status
    }
}`
const requestOptions = {
  method: 'POST',
  headers: { 'Content-Type': 'application/graphql', ...authHeader() },
  body: query
}
  return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
  return handleHttpResponse(response)
  .then(data => data.changeStateOfHpRequest)
  })
}